module.exports = __webpack_public_path__ + "assets/icon-trash.ea3c6ad8.svg";